// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ArbitrationDTO } from './arbitration-dto';
import { ClaimDocumentDTO } from './claim-document-dto';
import { ClaimItemDTO } from './claim-item-dto';
import { ClaimProposalDTO } from './claim-proposal-dto';
import { ClaimRespondentDTO } from './claim-respondent-dto';
import { ClaimResponseDocumentDTO } from './claim-response-document-dto';
import { ClaimStatusDTO } from './claim-status-dto';
import { EvidenceChaserDTO } from './evidence-chaser-dto';
import { OrderWithOrderCustomersDTO } from './order-with-order-customers-dto';
import { OrganizationDTO } from './organization-dto';
import { TenancyAccessMode } from './tenancy-access-mode';
import { UserDTO } from './user-dto';

/**
 * 
 * @export
 * @interface ClaimDTO
 */
export interface ClaimDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    id: string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof ClaimDTO
     */
    organization: OrganizationDTO;
    /**
     * 
     * @type {TenancyAccessMode}
     * @memberof ClaimDTO
     */
    accessMode?: TenancyAccessMode;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    status: ClaimDTOStatusEnum;
    /**
     * 
     * @type {Array<ClaimStatusDTO>}
     * @memberof ClaimDTO
     */
    statuses: Array<ClaimStatusDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    repositMessage?: string;
    /**
     * 
     * @type {Array<ClaimRespondentDTO>}
     * @memberof ClaimDTO
     */
    respondents: Array<ClaimRespondentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    repositMessagePublishedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    agentResponse?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    tenantDisputeMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    agentResponsePublishedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimDTO
     */
    originalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDTO
     */
    finalAmount?: number;
    /**
     * 
     * @type {Array<ClaimItemDTO>}
     * @memberof ClaimDTO
     */
    items: Array<ClaimItemDTO>;
    /**
     * 
     * @type {Array<ClaimDocumentDTO>}
     * @memberof ClaimDTO
     */
    documents: Array<ClaimDocumentDTO>;
    /**
     * 
     * @type {Array<ClaimResponseDocumentDTO>}
     * @memberof ClaimDTO
     */
    responseDocuments: Array<ClaimResponseDocumentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    publishedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    supplierPaidAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    substantiationDeadline?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimDTO
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    bankTransactionsEnabledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    createdByUserId: string;
    /**
     * 
     * @type {UserDTO}
     * @memberof ClaimDTO
     */
    createdByUser: UserDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDTO
     */
    autoChargeEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    legacyId?: string;
    /**
     * 
     * @type {ArbitrationDTO}
     * @memberof ClaimDTO
     */
    arbitration?: ArbitrationDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDTO
     */
    mediationEnabled: boolean;
    /**
     * 
     * @type {Array<ClaimProposalDTO>}
     * @memberof ClaimDTO
     */
    proposals: Array<ClaimProposalDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    adjudicationFeeOrderId?: string;
    /**
     * 
     * @type {OrderWithOrderCustomersDTO}
     * @memberof ClaimDTO
     */
    adjudicationFeeOrder?: OrderWithOrderCustomersDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDTO
     */
    disputeFeeWaived: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    adjudicationDocumentationGeneratedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    adjudicationSentAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    adjudicationOutcomeExpectedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    insuranceDatesSetAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    insuranceSentAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    insuranceOutcomeExpectedAt?: string;
    /**
     * 
     * @type {Array<EvidenceChaserDTO>}
     * @memberof ClaimDTO
     */
    evidenceChasers?: Array<EvidenceChaserDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    resolvedForSupplierAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDTO
     */
    evidenceChaserSkippedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimDTOStatusEnum {
    DRAFT = 'DRAFT',
    AWAITINGREVIEW = 'AWAITING_REVIEW',
    DEACTIVATED = 'DEACTIVATED',
    AWAITINGRESPONDENTS = 'AWAITING_RESPONDENTS',
    MEDIATION = 'MEDIATION',
    AWAITINGARBITRATIONADMINFEE = 'AWAITING_ARBITRATION_ADMIN_FEE',
    AWAITINGARBITRATION = 'AWAITING_ARBITRATION',
    ARBITRATED = 'ARBITRATED',
    RESOLVED = 'RESOLVED',
    AWAITINGSUBSTANTIATION = 'AWAITING_SUBSTANTIATION',
    AWAITINGEVIDENCEREVIEW = 'AWAITING_EVIDENCE_REVIEW',
    EVIDENCEREVIEW = 'EVIDENCE_REVIEW',
    AWAITINGADDITIONALINFORMATION = 'AWAITING_ADDITIONAL_INFORMATION',
    DECLINED = 'DECLINED',
    AWAITINGPAYOUT = 'AWAITING_PAYOUT',
    ARBITRATION = 'ARBITRATION',
    INSURANCECLAIM = 'INSURANCE_CLAIM'
}



